import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import TabsLayout from "@layouts/tabs";
import { PATHS } from "@constants/Paths";
import messages from "./messages.i18n";
import { RefetchProvider } from "@piiqtechnologies/ui-lib";
import { useDebounce } from "@piiqtechnologies/ui-lib";
import { AdminActions } from "@components/admin";
import { PeekGrid, PeekPaper } from "@piiqtechnologies/ui-components";
import SearchText from "@components/common/search-text";
import { AddUserForm, AddCommunityForm, AddOrganizationForm, AddFeatureForm, } from "@components/admin/admin-actions/admin-actions-forms";
import AppHeader from "@components/app-header";
import AddMagicButtonForm from "@components/admin/admin-actions/admin-actions-forms/add-magic-button/AddMagicButton";
const TabActions = ({ search, setSearch }) => {
    return React.createElement(SearchText, { searchText: search, onChange: setSearch });
};
export const AdminHomeLayout = () => {
    const intl = useIntl();
    const location = useLocation();
    const [contextLabel, setContextLabel] = useState("");
    const navigate = useNavigate();
    const [tabValue, setTabValue] = useState(null);
    const [search, setSearch] = useState(null);
    const debouncedSearch = useDebounce(search, 700);
    const [openEditUserDialog, setOpenEditUserDialog] = useState(false);
    const [handleInfoUpdate, setHandleInfoUpdate] = useState(false);
    useEffect(() => {
        if (location.pathname.endsWith("/admin")) {
            navigate(PATHS.ADMIN_COMMUNITIES);
        }
    }, []);
    const handleSelectNewAdd = (label) => {
        setContextLabel(label);
        toggleEditUserDialog();
    };
    const toggleEditUserDialog = () => {
        setOpenEditUserDialog((prevDialogOpenState) => !prevDialogOpenState);
    };
    const toggleInfoUpdate = () => {
        setHandleInfoUpdate(!handleInfoUpdate);
    };
    const handleTabChange = (value) => {
        navigate(value);
    };
    useEffect(() => {
        const adminURLSegments = location.pathname.split("/");
        const activeTabURL = adminURLSegments.pop() || adminURLSegments.pop();
        const isValidTabValue = ADMIN_TABS.map(({ value }) => value).includes(activeTabURL);
        setTabValue((isValidTabValue && activeTabURL) || PATHS.ADMIN);
        setSearch(null);
    }, [location.pathname]);
    const ADMIN_TABS = [
        {
            value: PATHS.ADMIN_COMMUNITIES,
            label: messages.peekAdminCommunitiesLabel,
        },
        {
            value: PATHS.ADMIN_USERS,
            label: messages.peekAdminUsersLabel,
        },
        {
            value: PATHS.ADMIN_ORGANIZATIONS,
            label: messages.peekAdminOrganizationsLabel,
        },
        {
            value: PATHS.ADMIN_MAGIC_BUTTONS,
            label: messages.peekAdminMagicButtonsLabel,
        },
        {
            value: PATHS.ADMIN_BETA_FEATURES,
            label: messages.peekAdminBetaFeaturesLabel,
        },
    ];
    const dialogFormMap = {
        [intl.formatMessage(messages.userOption)]: (React.createElement(AddUserForm, { onClose: toggleEditUserDialog, handleInfoUpdate: toggleInfoUpdate })),
        [intl.formatMessage(messages.communityOption)]: React.createElement(AddCommunityForm, { onClose: toggleEditUserDialog }),
        [intl.formatMessage(messages.organizationOption)]: React.createElement(AddOrganizationForm, { onClose: toggleEditUserDialog }),
        [intl.formatMessage(messages.magicButtonOption)]: React.createElement(AddMagicButtonForm, { onClose: toggleEditUserDialog }),
        [intl.formatMessage(messages.betaFeatureOption)]: React.createElement(AddFeatureForm, { onClose: toggleEditUserDialog }),
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekGrid, { item: true, xs: 12, display: "flex", justifyContent: "space-between" },
            React.createElement(AppHeader, { headerLabel: intl.formatMessage(messages.peekAdminTitle) }),
            React.createElement(AdminActions, { onSelectNewAdd: handleSelectNewAdd })),
        React.createElement(PeekGrid, { item: true, xs: 12 },
            React.createElement(PeekPaper, { sx: { p: 1.5 } },
                React.createElement(RefetchProvider, null,
                    React.createElement(TabsLayout, { tabs: ADMIN_TABS, activeTab: tabValue, onTabChange: handleTabChange, TabAction: React.createElement(TabActions, { search: search, setSearch: setSearch }), TabContent: React.createElement(Outlet, { context: { search: debouncedSearch, handleInfoUpdate: handleInfoUpdate } }) }),
                    openEditUserDialog && dialogFormMap[contextLabel])))));
};
export default AdminHomeLayout;
